import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'react-final-form';
import {
  Col,
  languageOptions,
  MultiSelection,
  Row,
  Select,
} from '@folio/stripes-components';

const propTypes = {
  fieldName: PropTypes.string,
  fieldData: PropTypes.object,
};

function LanguageFieldType({ fieldName, fieldData }) {
  const intl = useIntl();
  const langOptions = languageOptions(intl);

  const defaultValueFormatter = () => {
    const defaultData = fieldData?.dataOptionsLimits?.length
      ? fieldData.dataOptionsLimits
      : langOptions;

    return defaultData;
  };

  return (
    <Row>
      <Col xs={6}>
        <Field
          id={`${fieldName}.dataOptionsLimits`}
          name={`${fieldName}.dataOptionsLimits`}
          type="text"
          component={MultiSelection}
          itemToString={(item) => (item ? item.value : '')}
          dataOptions={langOptions}
          fullWidth
          label={
            <FormattedMessage
              id="ui-plugin-inventory-templates.templateField.dataOptions.label"
              defaultMessage="Data options"
            />
          }
        />
      </Col>
      <Col xs={6}>
        <Field
          id={`${fieldName}.defaultValue`}
          name={`${fieldName}.defaultValue`}
          type="text"
          component={Select}
          dataOptions={[
            {
              label: intl.formatMessage({
                id: 'ui-plugin-inventory-templates.templateField.defaultValue.select.chooseMsg',
                defaultMessage: 'Choose default value',
              }),
              value: '',
            },
            ...defaultValueFormatter(),
          ]}
          fullWidth
          label={
            <FormattedMessage
              id="ui-plugin-inventory-templates.templateField.defaultValue.label"
              defaultMessage="Default value"
            />
          }
        />
      </Col>
    </Row>
  );
}

LanguageFieldType.propTypes = propTypes;

export default LanguageFieldType;
